// extracted by mini-css-extract-plugin
module.exports = {"ArithmeticCodecUpdateMsg":"ArithmeticCodecUpdateMsg_ArithmeticCodecUpdateMsg__3mTGX"};